import { useState, type ReactNode } from 'react';
import { CaretDownOutlined } from '@ant-design/icons';

interface Props {
  num?: string;
  label: string;
  count?: string | number | null;
  action?: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function NumberedSection({
  num,
  label,
  count,
  action,
  children,
  defaultOpen = true,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section style={{ padding: '14px 0', borderBottom: '1px solid var(--border-soft)' }}>
      <header
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '0 16px',
          marginBottom: open ? 12 : 0,
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        {num != null && (
          <span
            style={{
              width: 18,
              height: 18,
              borderRadius: 4,
              background: 'var(--surface-2)',
              color: 'var(--ink-2)',
              fontSize: 10,
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontVariantNumeric: 'tabular-nums',
              flexShrink: 0,
              fontFamily: 'var(--font-mono)',
            }}
          >
            {num}
          </span>
        )}
        <h3
          style={{
            margin: 0,
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '.08em',
            textTransform: 'uppercase',
            color: 'var(--ink)',
            flex: 1,
          }}
        >
          {label}
        </h3>
        {count != null && count !== '' && (
          <span
            style={{
              fontSize: 11,
              color: 'var(--ink-3)',
              fontFamily: 'var(--font-mono)',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {count}
          </span>
        )}
        {action}
        <span
          style={{
            color: 'var(--ink-3)',
            display: 'inline-flex',
            transform: open ? 'rotate(0)' : 'rotate(-90deg)',
            transition: 'transform .15s ease',
          }}
        >
          <CaretDownOutlined style={{ fontSize: 11 }} />
        </span>
      </header>
      {open && <div style={{ padding: '0 16px' }}>{children}</div>}
    </section>
  );
}
